import { register, CloudObject, Tag, Transaction, defineProperty, defineRelation } from 'olympe';
import InspectionEntity from "./InspectionEntity";
import FactorTarget from "./FactorTarget";

/**
 * @extends {CloudObject}
 */
export default class WeightingFactor extends CloudObject {

    /**
     * Creates an instance of WeightingFactor.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(WeightingFactor);
    }
    
    /**
     * @return {number}
     */
    getValue() {
        return this.get(WeightingFactor.valueProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<number>}
     */
    observeValue($) {
        return this.observe($, WeightingFactor.valueProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {number} value
     */
    static setValue(transaction, instance, value) {
        transaction.update(instance, WeightingFactor.valueProp, value);
    }

}

// Hardcoded tags
register('01880b3fb379adeab55f', WeightingFactor);
WeightingFactor.valueProp = defineProperty('01880b3ff5a9938a55d4');
WeightingFactor.targetRel = defineRelation('01880b40d1795a00f94d', WeightingFactor, FactorTarget);
WeightingFactor.itemRel = defineRelation('01894f168fb8484869a9', WeightingFactor, InspectionEntity);
